import React, { Component } from 'react';
import radium, { Style } from 'radium';
import Relay from 'react-relay/classic';
import LearningBlockCard from '../../../../admin/views/Creator/cards/LearningCards/BlockLesson';

const styles = getStyles(); // eslint-disable-line no-use-before-define

class BlockCard extends Component {
  renderNoQuestionView = () => <div style={styles.noQuestion}>Empty lesson</div>;

  render() {
    const blockInfoLength = this.props.rootQ.blockInfo.length;
    if (blockInfoLength === 0) {
      return this.renderNoQuestionView();
    }
    return (
      <div className="BlockCardContainer">
        <LearningBlockCard
          editable={false}
          card={this.props.rootQ}
          courseId={this.props.courseId}
          preview={this.props.preview}
          guestMode={this.props.guestMode}
          setScrollPM={this.props.setScrollPM}
        />
        <Style rules={styles.classBased} scopeSelector=".BlockCardContainer" />
      </div>
    );
  }
}

function getStyles() {
  return {
    classBased: {
      '': {
        width: '100%'
      }
    },
    noQuestion: {
      width: '85%',
      maxWidth: '809px',
      margin: '0px auto',
      backgroundColor: 'transparent',
      zIndex: '2',
      paddingTop: '0px',
      height: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '32px'
    }
  };
}

const BlockMediaType = Relay.QL`
  fragment on BlockMediaType {
    video {
      src
      hlsUrl
      thumbnail
      isProcessing
      meta
    }
    audio {
      src
      thumbnail
      isProcessing
    }
    image {
      src
      placeHolder
      thumbnail
      isProcessing
      size
    }
    embed {
      src
      type
    }
    attachment {
      src
      fileName
      fileSize
    }
  }
`;

export default Relay.createContainer(radium(BlockCard), {
  initialVariables: {},
  fragments: {
    rootQ: () => Relay.QL`
      fragment on Card {
        pid
        name
        completionType
        minProgressMeasure
        performance {
          completionStatus
          progressMeasure
          scaledProgressMeasure
          blockPerformance
        }
        blockInfo {
          id
          items {
            html
            media {
              ${BlockMediaType}
            }
            avatar {
              media {
                image {
                  key
                  src
                  thumbnail
                  originalUrl
                }
              }
            }
            background {
              media {
                image {
                  key
                  src
                  thumbnail
                  originalUrl
                }
              }
            }
            name
            caption
            questionText
            paragraph
            heading
            subheading
            front
            {
              media {
                ${BlockMediaType}
              }
              description
              type
            }
            back
            {
              media {
                ${BlockMediaType}
              }
              description
              type
            }
          }
          pid
          type
          variant
          family
          settings {
            zoomOnClick
            paddingBottom
            paddingTop
            backgroundColor
            imagePosition
            opacity
            opacityColor
          }
        }
      }
    `
  }
});
